'use client'

import { useEffect } from 'react'
import type { FieldValues, Path, UseFormSetValue } from 'react-hook-form'

import type { GatewayListSelectOption } from '../constants/gatewayListFilters.const'
import { coerceGatewayListFilterSelections } from '../domain/coerceGatewayListFilterSelections'
import type { GatewayListFilterFormSlice } from '../types/gatewayListFilters.types'

type UseGatewayListFormFilterCoercionParams<T extends FieldValues> = {
  filters: GatewayListFilterFormSlice
  setValue?: UseFormSetValue<T>
  statusOptions: readonly GatewayListSelectOption[]
  runtimeOptions: readonly GatewayListSelectOption[]
  moduleOptions: readonly GatewayListSelectOption[]
  projectKeyOptions?: readonly GatewayListSelectOption[]
}

export function useGatewayListFormFilterCoercion<T extends FieldValues>({
  filters,
  setValue,
  statusOptions,
  runtimeOptions,
  moduleOptions,
  projectKeyOptions = [],
}: UseGatewayListFormFilterCoercionParams<T>) {
  useEffect(() => {
    if (!setValue) {
      return
    }

    const updates = coerceGatewayListFilterSelections(filters, {
      status: statusOptions,
      runtime: runtimeOptions,
      module: moduleOptions,
      projectKey: projectKeyOptions,
    })

    if (updates.status !== undefined) {
      setValue('status' as Path<T>, updates.status as T[Path<T>])
    }
    if (updates.runtime !== undefined) {
      setValue('runtime' as Path<T>, updates.runtime as T[Path<T>])
    }
    if (updates.feed !== undefined) {
      setValue('feed' as Path<T>, updates.feed as T[Path<T>])
    }
  }, [filters, moduleOptions, projectKeyOptions, runtimeOptions, setValue, statusOptions])
}
